/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RecordExportPlatformType {
  SALESFORCE = 'salesforce',
  PIPEDRIVE = 'pipedrive',
  NOTION = 'notion',
  TEAMS = 'teams',
  SLACK = 'slack',
  CONFLUENCE = 'confluence',
  EMAIL = 'email',
}
